<template>
  <div>
    <div class="row m-0 justify-content-center py-3" v-if="isLoading">
      <div class="spinner__medium--blue">
        <b-spinner label="Loading..."></b-spinner>
      </div>
    </div>
    <div
      v-else
      @click="goToDetail(item)"
      v-for="(item, i) in dataList" :key="i"
    >
      <div class="dashboard__notif-and-todo--content" :style="!item.unread ? 'background:#F5F5F5;' : 'background:#FFFFFF'">
        <div class="row mb-2">
          <div class="col-md-10">
            <div class="d-flex">
              <img class="mr-2" :src="item.messageImage" alt="" height="20px" width="20px">
              <p class="mr-2" style="font-size: 12px; font-weight: 600;">{{item.messageType}}</p>
              <p class="mr-2" style="font-size: 12px; font-weight: 600;">-</p>
              <p class="mr-2" style="font-size: 12px; font-weight: 600;">{{item.status}}</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="d-flex">
              <p class="mr-2" style="font-size: 12px; font-weight: 400; color: #B6B6B6;">{{getFullDate(item.date)}}</p>
              <p style="font-size: 12px; font-weight: 400; color: #B6B6B6;">{{getTime(item.date)}}</p>
            </div>
          </div>
        </div>
        <p style="font-size: 16px; font-weight:600; color: #686868;">{{item.message}}</p>
        <div class="d-flex mt-2"> 
          <p class="mr-2" style="font-size:14px; font-weight:400; color:#B6B6B6;" >{{item.referenceNumber}}</p>
          <p class="mr-2" style="font-size:14px; font-weight:400; color:#B6B6B6;" >-</p>
          <p class="mr-2" style="font-size:14px; font-weight:400; color:#B6B6B6;" >{{item.originCity || item.origin}} to {{item.destinationCity || item.destination}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as moment from 'moment'
import * as momentTimezone from 'moment-timezone'
import dashboardMixin from '@/mixin/dashboard/invoice_notif_todolist'

export default {
  name: 'DashboardNotifAndTodoList',
  props: {
    dataList: Array,
    isLoading: Boolean,
    tabActive: String
  },
  data: () => ({
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
  }),
  mixins: [dashboardMixin],
  methods: {
    getDate (item) {
      return moment(item).format('MMM, DD')
    },
    getTime (item) {
      const newTime = momentTimezone(item).tz(this.timezone).format('LT')
      return newTime
    },
    getFullDate (item) {
      const newTime = moment(item).format('LL')
      return newTime
    },
    goToDetail (item) {
      if (this.tabActive.toLowerCase() === 'to do list') {
        const payload = {
          id: item.referenceId,
          referenceNumber: item.referenceNumber,
          topic: item.topic
        }
        this.$store.dispatch('dashboard/UPDATE_ISREAD_TODO', payload)
        this.$router.push(this.getRouterNameDashboard(item))
      } else {
        const payload = {
          referenceId: item.id,
          referenceNumber: item.referenceNumber,
          topic: item.topic
        }
        this.$store.dispatch('dashboard/UPDATE_ISREAD_NOTIF', payload)
        // this.$router.push(this.getRouterNameDashboard(item))
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/notifAndToDo/List.vue